import SENTRY_LEVEL from 'constants/sentryLevel.const';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import fromAnyToString from 'utils/converters/fromAnyToString';
import asObject from 'utils/objects/asObject.util';
import isEnumVal from 'utils/predicates/enum/isEnumVal.util';

const determineLevel = (options) =>
  isEnumVal(SENTRY_LEVEL, options?.level)
    ? options?.level
    : options?.error instanceof Error
      ? SENTRY_LEVEL.error
      : SENTRY_LEVEL.log;

const determineLogger = (options) =>
  Array.isArray(options?.logger) ? options?.logger.map(fromAnyToTrimmed).join(' ') : fromAnyToString(options?.logger);

const fromOptionsToSentryData = (options) =>
  isEnumVal(SENTRY_LEVEL, options)
    ? {
        // v2
        logger: 'UNKNOWN',
        tags: {},
        extra: {},
        message: '',
        level: options,
      }
    : {
        logger: determineLogger(options),
        tags: asObject(options?.tags),
        extra: asObject(options?.extra),
        message: fromAnyToString(options?.message),
        error: options?.error,
        level: determineLevel(options),
        fingerprint: Array.isArray(options?.fingerprint) ? options?.fingerprint : [],
        user: options?.user,
        contexts: options?.contexts,
        requestSession: options?.requestSession,
        propagationContext: options?.propagationContext,
      };

export default fromOptionsToSentryData;
